/*
 * @Copyright: 中国信息安全测评中心
 * @Author: xiaowenwen
 * @Date: 2021-03-02 11:50:31
 * @LastEditTime: 2022-03-29 11:02:26
 * @Description:
 */
/**
 * JavaScript Document
 * Version: 1.0.0
 * Date: 4/20/2020
 * Author: Liu Changkun
 * Copyright: www.east.net
 */
import http from "@/utils/http";
const url = action => `/sync/util/${action[0]}`;

export default class UTIL {
  static OPTIONS(params) {
    return http.get(url`options`, { params });
  }
  static SCHEMAS(params) {
    return http.get(url`schemas`, { params });
  }
  static MANAGERS(params) {
    return http.get(url`managers`, { params });
  }
  static DESCRIPTORS(params) {
    return http.get(url`descriptors`, { params });
  }
  static EXTENSIONS(params) {
    return http.get(url`extensions`, { params });
  }
  static GENEXCEL(params) {
    //return http.post(url`genexcel`, { params });
    return http.post(url`genexcel`, params, {
      responseType: "blob"
    });
  }
}
